import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'
import { t } from 'ttag'
import introStyles from '../IntroPage/IntroPage.module.scss'
import { BellCurve } from 'components/shared/BellCurve/BellCurve'
import { Stats } from 'components/shared/Stats/Stats'
import { CandidateBellCurve } from './CandidateBellCurve'

import styles from './GMA.module.scss'
import reportStyles from '../../Report.module.scss'

import { useGMAState } from 'components/modals/TestsReportModal/tabs/ProcessingSpeed/hooks'

export const GMAPage = ({ language, response, isCandidate, candidates }) => {
  const {
    state: { translations, scores, allScores, descriptions },
  } = useGMAState({
    factor: 'GMA',
    language,
    response,
    isCandidate,
    includeNormComparison: true,
    candidates,
  })

  return (
    <Box
      className={cx(reportStyles.containerWhite, {
        [styles.candidateGma]: isCandidate,
      })}
      direction="column"
      data-testid="report"
    >
      <div
        className={cx(introStyles.header, introStyles.headerPadding, {
          [styles.candidateHeader]: isCandidate,
        })}
      >
        <div className={introStyles.name}>{t`General mental ability`}</div>
        <div className={introStyles.position}>
          {t`Ability to learn, understand instructions, and solve problems`}
        </div>
      </div>

      <div className={cx({ [styles.candidateStats]: isCandidate })}>
        <Stats
          scores={scores}
          candidates={candidates}
          single
          className={isCandidate ? styles.candidateStatsBox : undefined}
        />
      </div>

      <div
        className={cx(styles.bellCurve, {
          [styles.candidateBellCurve]: isCandidate,
        })}
      >
        {isCandidate ? (
          <CandidateBellCurve score={allScores[0].score} language={language} />
        ) : (
          <BellCurve
            allScores={allScores}
            candidates={candidates}
            high
            single
          />
        )}
      </div>

      <div
        className={cx(styles.description, {
          [styles.candidateDescription]: isCandidate,
        })}
      >
        {translations[0].translation.abstract.map((par, index) => (
          <React.Fragment key={index}>
            <div className={styles.paragraph}>{par}</div>
            {isCandidate || ![3, 0].includes(index) ? null : <br />}
          </React.Fragment>
        ))}
        {isCandidate ? null : <br />}
        <div className={cx(styles.paragraph, styles.bold)}>
          {descriptions[0]}
          {translations[0].translation.judgement[0]}
          {descriptions[1]}
        </div>
      </div>
    </Box>
  )
}
